/*
* ------------------------------
* GOOGLE ANALYTICS FORM
* ------------------------------
*/

export async function gaSendTagForm($form) {
    let $this = $form;
    // if no class say the contrary (used mostly for popup form) or
    // if not already sent
    if (
        !$this.classList.contains('tag_already_send') &&
        !$this.classList.contains('ga_no_submit')
    ) {
        if (typeof $this.dataset.gaformtag !== 'undefined') {
            let tag = $this.dataset.gaformtag;
            if (tag === '') {
                tag = 'Default form';
            }
            if (typeof gtag !== 'undefined') {
                gtag('event', tag, {
                    'event_category': 'submit'
                });
            } else if (typeof ga !== 'undefined') {
                ga('send', 'event', 'submit', tag);
            }
        }
    }
}
